import React, { useState, useEffect } from 'react'
import {
  Datagrid,
  TextField,
  useTranslate,
  Pagination,
  ListContextProvider,
  useList,
  TextInput,
  ListToolbar,
  BooleanInput
} from 'react-admin'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { FormattedTextFieldWithStatus } from '../sales/reservation/helper/FormattedTextFieldWithStatus'
import { PENDING, PENDING_BILLING } from '../sales/reservation/logic/common/state'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'

function AirNetviaxTicketsList() {
  const translate = useTranslate()
  const [isLoading, setIsLoading] = useState(false)
  const [filter, setFilter] = useState({})
  const [displayedFilters, setDisplayedFilters] = useState({})
  const [pagination, setPagination] = useState({ page: 1, perPage: 10 })
  const [airTickets, setAirTickets] = useState([])
  const [timeoutFilters, setTimeoutFilters] = useState()
  const [total, setTotal] = useState(0)

  useEffect(() => {
    getAirTickets()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, pagination])

  const getAirTickets = async () => {
    try {
      setIsLoading(true)
      const params = {
        order_by: '-id',
        skip: (pagination.page - 1) * pagination.perPage,
        limit: pagination.perPage,
        ...filter
      }
      const airTicketsAux = await reservationServices.getAirNetviaxTickets(params)
      if (airTicketsAux) {
        setAirTickets(airTicketsAux.data)
        setTotal(airTicketsAux.total)
        setIsLoading(false)
      } else {
        setAirTickets([])
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false)
      setAirTickets([])
    }
  }

  const listContext = useList({
    data: airTickets,
    isLoading,
    sort: { field: 'id', order: 'DESC' },
    displayedFilters: displayedFilters,
    filterValues: filter,
    ...pagination
  })

  const onShowFilter = (filterName) => {
    setDisplayedFilters((displayedFilters) => ({
      ...displayedFilters,
      [filterName]: true,
    }))
  }

  const onHideFilter = (filterName) => {
    const displayedFiltersAux = { ...displayedFilters }
    delete displayedFiltersAux[filterName]
    setDisplayedFilters(displayedFiltersAux)
    const filterAux = { ...filter }
    delete filterAux[filterName]

    if (JSON.stringify(filter) !== JSON.stringify(filterAux)) {
      setFilter(filterAux)
    }
  }

  const onChangeFilters = (filters, displayedFiltersAux) => {
    setDisplayedFilters(displayedFiltersAux)

    clearTimeout(timeoutFilters)
    const timeout = setTimeout(() => {
      Object.entries(filters).forEach((elem) => {
        const [key, value] = elem
        if (!value) {
          delete filters[key]
        }
      })

      if (JSON.stringify(filter) !== JSON.stringify(filters)) {
        setFilter(filters)
      }
      onChangePagination('page', 1)
    }, 1000)
    setTimeoutFilters(timeout)
  }

  const onChangePagination = (field, value) => {
    if (pagination[field] !== value) {
      setPagination(current => ({
        ...current,
        [field]: value
      }))
      setAirTickets([])
    }
  }

  const AirTicketsFilters = [
    <BooleanInput label={translate('ra.field.in_reserve')} source='air_search__is_imported' defaultValue={false} />,
    <TextInput label={translate('ra.field.pnr')} source='source_record_locator' defaultValue='' />,
    <TextInput label={translate('ra.field.gds')} source='gds' defaultValue='' />,
    <TextInput label={translate('ra.field.e_ticket')} source='document_number' defaultValue='' />,
    <TextInput label={translate('ra.field.passenger')} source='passenger' defaultValue='' />,
    <TextInput label={translate('ra.field.reservation_number')} source='reservation__number__ilike' defaultValue='' />,
  ]

  return (
    <ListContextProvider
      value={{
        ...listContext,
        ...pagination,
        filterValues: filter,
        displayedFilters: displayedFilters,
        setFilters: onChangeFilters,
        showFilter: onShowFilter,
        hideFilter: onHideFilter,
      }}
    >
      <ListToolbar actions={<ListViewTopToolbar />} filters={AirTicketsFilters} />
      <Datagrid isLoading={isLoading} bulkActionButtons={null}>
        <FormattedTextFieldWithStatus
          label={translate('ra.field.status')}
          source='status'
          sortable={false}
          getValue={(value) => value === PENDING ? PENDING_BILLING : value}
        />
        <TextField
          label={translate('ra.field.pnr')}
          source='source_record_locator'
          sortable={false}
        />
        <TextField
          label={translate('ra.field.gds')}
          source='gds'
          sortable={false}
        />
        <TextField
          label={translate('ra.field.e_ticket')}
          source='document_number'
          sortable={false}
        />
        <TextField
          label={translate('ra.field.passenger')}
          source='passenger'
          sortable={false}
        />
        <FormattedTextFieldWithStatus
          label={translate('ra.field.reservation_number')}
          source='number'
          sortable={false}
          getValue={(value) => value ? value : PENDING_BILLING}
          translateValue={(value) => value === PENDING_BILLING ? true : false}
        />
      </Datagrid>
      <Pagination
        {...pagination}
        total={total}
        isLoading={isLoading}
        setPage={(value) => onChangePagination('page', value)}
        setPerPage={(value) => onChangePagination('perPage', value)}
      />
    </ListContextProvider>
  )
}

export default AirNetviaxTicketsList
